import { HttpClient } from '@angular/common/http';
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';
// import 'jquery';
import * as bootstrap from "bootstrap";
import * as $ from 'jquery';
import { loadLanguageData } from 'src/app/state/actions';
import { Store } from '@ngrx/store';
import { selectLanguageData } from 'src/app/state/selectors';

@Component({
  selector: 'app-provisioning',
  templateUrl: './provisioning.component.html',
  styleUrls: ['./provisioning.component.css']
})
export class ProvisioningComponent implements OnInit, OnDestroy {
  // provisioningData: any[] = [];
  provisioningData: any;
  dtTrigger: Subject<any> = new Subject<any>();
  dtOptions: DataTables.Settings = {};
  dtTrigger1: Subject<any> = new Subject<any>();
  dtOptions1: DataTables.Settings = {};
  dtTrigger2: Subject<any> = new Subject<any>();
  dtOptions2: DataTables.Settings = {};
  lang: any = {};
  languageData: any;
  selectedLanguage: any;
  showfilter: boolean = true;
  modalTitle: any;
  fileUrl: any = '';
  logFileData: any = [];
  logLabels = [
    'Timestamp',
    'Log Type',
    'Test Case',
    'Data Set',
    'Step No',
    'Item',
    'Step Info',
    'Result',
    'Duration'
  ]
  videoUrl: any = '';
  imageUrls: any = [];
  imageNames: any;
  isVideoLoaded: boolean=true;
  dtInstance: DataTables.Api;
  languageData$: Observable<any>;
  private destroy$ = new Subject<void>();

  constructor(
    private http: HttpClient,
    private store: Store<{ languageData: [] }>,
    private cdr: ChangeDetectorRef
  ) {
    this.languageData$ = store.select(selectLanguageData);
   }

  ngOnInit(): void {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'Provisioning Queues');
    },100)
    this.getLanguageTokens();
    this.getProvisioningData();

    this.dtOptions = {
      pagingType: 'simple_numbers',
      language: {
        searchPlaceholder: 'Search here'
      },
      paging: true,
      pageLength: 10,
      lengthMenu: [
        [5, 10, 25, 50, -1],
        [5, 10, 25, 50, 'All']
      ],
      order: [[1, 'asc']],
      destroy:true
    };

    this.dtOptions1 = this.dtOptions2 = {
      pagingType: 'simple_numbers',
      language: {
        searchPlaceholder: 'Search here'
      },
      paging: true,
      pageLength: 10,
      lengthMenu: [
        [5, 10, 25, 50, -1],
        [5, 10, 25, 50, 'All']
      ],
      destroy:true
    };
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.dtTrigger1.unsubscribe();
    this.dtTrigger2.unsubscribe();
  }

  getProvisioningData(): void {
    const accessToken = sessionStorage.getItem('accessToken');
    const provisioningApi = '/api/ap/customer/provisioningData/listQueues';

    this.http.get(environment.apiUrl + provisioningApi, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response['status'] === 200 || response['statusCode'] === 200) {
        // this.provisioningData = []
        this.provisioningData = response.data;
        // if ($.fn.dataTable?.isDataTable('#DataTables_Table_0')) {
        //   $('#DataTables_Table_0').DataTable().destroy();
        // }
        setTimeout(() => {
          this.dtTrigger.next(null); // Trigger DataTable after data is loaded
        }, 100);
        console.log('this.provisioningData', this.provisioningData)
      } else {
        Swal.fire({ title: 'Error', text: response.message });
      }
    }, (error) => {
      Swal.fire({ title: 'Error', text: error.message });
    });

  }

  public getLanguageTokens(): void {
    // const body = {
    //   project: "Admin Portal",
    //   url: "Provisioning"
    // };

    // this.http.post('https://languageengineapi.aitestpro.com/string/project-url-strings', body, {
    //   headers: { 'Content-Type': 'application/json' },
    // }).subscribe((response: any) => {
    //   this.lang = {};
    //   this.languageData = response.strings;
    //   this.selectedLanguage = sessionStorage.getItem("language");
    //   for (let token of response.strings) {
    //     this.lang[token.key] = token[this.selectedLanguage];
    //   }
    // });

    // this.store.dispatch(loadLanguageData());
    
    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if(data){
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(()=>{
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
          this.logLabels = [
            this.lang?.Timestamp,
            this.lang?.Log_Type,
            this.lang?.Test_Case,
            this.lang?.Data_Set,
            this.lang?.Step_No,
            this.lang?.Item,
            this.lang?.Step_Info,
            this.lang?.Result,
            this.lang?.Duration
          ]
        },0)
      }
    })
  }

  async openModal(data: any, name) {
    this.modalTitle = name;
    let jsonData: any;
    try {
      jsonData = JSON.parse(data);
      // if(!name.includes('Customer')){
      //   jsonData = JSON.parse(data);
      // }else{
      //   jsonData = data;
      // }
    } catch (error) {
      console.error("Invalid JSON data:", error);
      return; // Exit the function if parsing fails
    }

    // const jsonDataElement = document.getElementById('jsonData');
    // if (jsonDataElement) {
    //   jsonDataElement.innerText = JSON.stringify(jsonData, null, 2);
    // }
    if (data == undefined || data == null || data == '') {
      const jsonDataElement = document.getElementById('jsonData');
      if (jsonDataElement) {
        jsonDataElement.innerText = 'No data available';
      }
    } else {
      let jsonData: any;
      try {
        jsonData = JSON.parse(data);
        // if(!name.includes('Customer')){
        //   jsonData = JSON.parse(data);
        // }else{
        //   jsonData = data;
        // }
      } catch (error) {
        console.error("Invalid JSON data:", error);
        return; // Exit the function if parsing fails
      }

      const jsonDataElement = document.getElementById('jsonData');
      if (jsonDataElement) {
        jsonDataElement.innerText = JSON.stringify(jsonData, null, 2);
      }
    }

    // Show the modal
    const modalElement = document.getElementById('dataModal');
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  closeModal() {
    const modalElement = document.getElementById('dataModal');
    console.log(modalElement)
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.hide();
    }
  }

  handleRequeue(id: any) {
    Swal.fire({
      title: this.lang?.Alert,
      text: "Are you sure you want to requeue?",
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang?.Yes,
      cancelButtonText: this.lang?.No,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        // /customer/provisioningData/actionQueue/{id} - GET
        console.log('requeue', id)
        const endPoint = `/api/ap/customer/provisioningData/actionQueue/${id}`
        var accessToken = sessionStorage.getItem('accessToken');

        this.http.get(environment.apiUrl + endPoint, {
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + accessToken, },
        }).subscribe((response: any) => {
          if (response['status'] === 200 || response['statusCode'] === 200) {
            Swal.fire({
              title: 'Info',
              // text: 'Come back later to check the change in status and results',
              text: 'The provisioning queue status will be updated shortly.',
              allowOutsideClick: false
            }).then((result) => {
              // this.getProvisioningData();
              window.location.reload()
            });
          } else {
            Swal.fire({ title: 'Error', text: response.message, allowOutsideClick: false });
          }
        }, (error) => {
          Swal.fire({ title: 'Error', text: error.message, allowOutsideClick: false });
        });
      }
    })
  }

  handleDelete(id: any) {
    Swal.fire({
      title: this.lang?.Alert,
      text: "Are you sure you want to delete this Queue?",
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang?.Yes,
      cancelButtonText: this.lang?.No,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const endPoint = `/api/ap/customer/provisioningData/deleteQueue/${id}`
        var accessToken = sessionStorage.getItem('accessToken');

        this.http.delete(environment.apiUrl + endPoint, {
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + accessToken, },
        }).subscribe((response: any) => {
          if (response['status'] === 200 || response['statusCode'] === 200) {
            Swal.fire({
              title: 'Info',
              text: 'The provisioning queue has been deleted successfully.',
              allowOutsideClick: false
            }).then((result) => {
              // this.getProvisioningData();

              // this.provisioningData = this.provisioningData.filter(data=>data.id!=id)
              // console.log(this.provisioningData)
              // this.cdr.detectChanges();
              // this.dtTrigger.next(null)
              
              window.location.reload()
            });
          } else {
            Swal.fire({ title: 'Error', text: response.message, allowOutsideClick: false });
          }
        }, (error) => {
          Swal.fire({ title: 'Error', text: error.message, allowOutsideClick: false });
        });
      }
    })



  }

  parsedDataCache: { [key: string]: any } = {};
  getParseData(data) {
    // console.log({data},JSON.parse(data))
    // return data != null && data != undefined && data != '' ? JSON.parse(data) : []
    // if (this.parsedDataCache[data]) {
    //   return this.parsedDataCache[data];
    // }

    // Parse and cache the data
    const parsedData = data != null && data !== '' ? JSON.parse(data) : [];
    // this.parsedDataCache[data] = parsedData;
    return parsedData;
  }

  // openFile(response){
  //   let responseData = JSON.parse(response)
  //   console.log(responseData?.logfile)
  //   if(responseData?.logfile!=''&&responseData?.logfile!=undefined){
  //     fetch(responseData.logfile)
  //     .then(response => {
  //       console.log(response)
  //       return response.text()
  //     })
  //     .then(data => {
  //       console.log(response?.status,response?.statusCode)
  //       this.fileUrl = data;
  //       let fileData:any = this.fileUrl.split('\n')
  //       for(let i=0; i<fileData.length;i++){
  //         let currentFile = fileData[i].split('|')
  //         let obj = {
  //           timeStamp : currentFile[0]?.trim() !=undefined ? currentFile[0]?.trim().slice(0,19) : '',
  //           logType: currentFile[1]?.trim() ?? '',
  //           testCase: currentFile[3]?.trim() ?? '',
  //           dataSet: currentFile[4]?.trim() ?? '',
  //           stepNo: currentFile[5]?.trim() ?? '',
  //           item: currentFile[6]?.trim() ?? '',
  //           stepInfo: currentFile[7]?.trim() ?? '',
  //           result: currentFile[9]?.trim() ?? '',
  //           duration: currentFile[10]?.trim() ?? ''
  //         }
  //         this.logFileData.push(obj)
  //       }
  //       this.logFileData = this.logFileData.filter((log:any)=>log.timeStamp!='')
  //       console.log('this.logFileData',this.logFileData)
  //     })
  //     .catch(error => {
  //       if(responseData?.logfile.includes('commonresources2')){
  //         responseData?.logfile.replace('commonresources2','commonresources')
  //       }else if(responseData?.logfile.includes('commonresources1')){
  //         responseData?.logfile.replace('commonresources1','commonresources')
  //       }
  //       console.log(responseData?.logfile)
  //       fetch(responseData.logfile)
  //       .then(response => {
  //         console.log(response)
  //         return response.text()
  //       })
  //       .then(data => {
  //         console.log(response?.status,response?.statusCode)
  //         this.fileUrl = data;
  //         let fileData:any = this.fileUrl.split('\n')
  //         for(let i=0; i<fileData.length;i++){
  //           let currentFile = fileData[i].split('|')
  //           let obj = {
  //             timeStamp : currentFile[0]?.trim() !=undefined ? currentFile[0]?.trim().slice(0,19) : '',
  //             logType: currentFile[1]?.trim() ?? '',
  //             testCase: currentFile[3]?.trim() ?? '',
  //             dataSet: currentFile[4]?.trim() ?? '',
  //             stepNo: currentFile[5]?.trim() ?? '',
  //             item: currentFile[6]?.trim() ?? '',
  //             stepInfo: currentFile[7]?.trim() ?? '',
  //             result: currentFile[9]?.trim() ?? '',
  //             duration: currentFile[10]?.trim() ?? ''
  //           }
  //           this.logFileData.push(obj)
  //         }
  //         this.logFileData = this.logFileData.filter((log:any)=>log.timeStamp!='')
  //         console.log('this.logFileData',this.logFileData)
  //       })
  //       .catch(error => {
  //         console.error("Error loading the log file inside:", error);
  //       })
  //       console.error("Error loading the log file outside:", error);
  //     });
  //   }else{
  //     this.logFileData = []
  //   }
  // }

  openFile(response) {
    let responseData = JSON.parse(response);
    console.log(responseData?.logfile);

    if (responseData?.logfile) {
      const fetchLogFile = (logfileUrl) => {
        return fetch(logfileUrl)
          .then(response => {
            if (!response.ok) {
              throw new Error(`Failed to fetch: ${response.statusText}`);
            }
            return response.text();
          })
          .then(data => {
            console.log('Log file fetched successfully:', data);
            this.fileUrl = data;

            let fileData = this.fileUrl.split('\n');
            this.logFileData = fileData.map(line => {
              let currentFile = line.split('|');
              return {
                timeStamp: currentFile[0]?.trim()?.slice(0, 19) ?? '',
                logType: currentFile[1]?.trim() ?? '',
                testCase: currentFile[3]?.trim() ?? '',
                dataSet: currentFile[4]?.trim() ?? '',
                stepNo: currentFile[5]?.trim() ?? '',
                item: currentFile[6]?.trim() ?? '',
                stepInfo: currentFile[7]?.trim() ?? '',
                result: currentFile[9]?.trim() ?? '',
                duration: currentFile[10]?.trim() ?? ''
              };
            }).filter(log => log.timeStamp !== ''); // Filter out empty logs
            this.dtTrigger1.next(null)
            console.log('Processed log data:', this.logFileData);
          });
      };

      fetchLogFile(responseData.logfile)
        .catch(error => {
          console.error("Error loading the log file inside:", error);

          let adjustedLogfile = responseData.logfile;
          if (adjustedLogfile.includes('commonresources2')) {
            adjustedLogfile = adjustedLogfile.replace('commonresources2', 'commonresources');
          } else if (adjustedLogfile.includes('commonresources1')) {
            adjustedLogfile = adjustedLogfile.replace('commonresources1', 'commonresources');
          }

          console.log("Retrying with adjusted logfile URL:", adjustedLogfile);
          return fetchLogFile(adjustedLogfile)
            .catch(finalError => {
              console.error("Error loading the log file after adjustment:", finalError);
            });
        });
    } else {
      this.logFileData = [];
      this.dtTrigger1.next(null)
    }
  }

  closeFile(){
    this.logFileData=[]
  }

  copyToClipboard() {
    const copyText = document.getElementById("jsonData")?.innerText;

    if (copyText) {
      navigator.clipboard.writeText(copyText).then(
        () => {
          console.log("Copied the text: " + copyText);
        },
        (err) => {
          console.error("Unable to copy", err);
        }
      );
    }
  }

  openVideo(response: string) {
    let responseData = JSON.parse(response);
    if (responseData?.vidfile && responseData.vidfile != '') {
      this.videoUrl = responseData.vidfile;
      this.isVideoLoaded = true;
      console.log('Video URL:', this.videoUrl);
    } else {
      this.videoUrl = '';
      this.isVideoLoaded = false;
    }
  }

  onVideoError() {
    this.isVideoLoaded = false;
  }

  // openImage(response) {
  //   let responseData = JSON.parse(response)
  //   if (responseData?.screenshots != '' && responseData?.screenshots != undefined) {
  //     this.imageUrls = responseData.screenshots.map((url: string) => {
  //       // return url.replace('./public', environment.apiUrl+'/app');
  //       return url.replace('./public', environment.signupFormEnv + '/app');
  //     });
  //     this.dtTrigger2.next(null)
  //     this.imageNames = this.imageUrls.map((url: string) => {
  //       const fileName = url.split('/').pop()?.replace('.png', '');

  //       const match = fileName?.match(/^ss_\d+_(.*?)(?=_\d{4}-\d{2}-\d{2}T)/);

  //       if (match) {
  //         const formattedName = match[1].replace(/_/g, ' ').trim();
  //         console.log(formattedName); 
  //         return formattedName;
  //       }

  //       return '';
  //     });
  //     console.log(this.imageUrls,this.imageNames)
  //   } else {
  //     this.imageUrls = [];
  //     this.dtTrigger2.next(null);
  //   }
  // }

  async openImage(response) {
    let responseData = JSON.parse(response);
    if (responseData?.screenshots?.length) {
        this.imageUrls = await Promise.all(responseData.screenshots.map(async (url: string) => {
            const url1 = url.replace('./public', environment.signupFormEnv + '/app');
            try {
                const response = await fetch(url1);
                if (response.ok) {
                    return url1;
                } else {
                    return url.replace('./public', environment.apiUrl + '/api/ap/app');
                }
            } catch (error) {
                return url.replace('./public', environment.apiUrl + '/api/ap/app');
            }
        }));
        console.log('imageUrls', this.imageUrls);
        this.dtTrigger2.next(null);
        
        this.imageNames = this.imageUrls.map((url: string) => {
            const fileName = url.split('/').pop()?.replace('.png', '');
            const match = fileName?.match(/^ss_\d+_(.*?)(?=_\d{4}-\d{2}-\d{2}T)/);
            if (match) {
                const formattedName = match[1].replace(/_/g, ' ').trim();
                console.log(formattedName); 
                return formattedName;
            }
            return '';
        });
        console.log(this.imageUrls, this.imageNames);
    } else {
        this.imageUrls = [];
        this.dtTrigger2.next(null);
    }
}


}
